import { SquareArrowOutUpRight } from 'lucide-react';
import { TrackedButton } from 'src/components/tracked';

type OpenDatadogButtonProps = {
  readonly primaryClientName?: string;
  readonly coClientName?: string;
};

function OpenDatadogButton({ primaryClientName, coClientName }: OpenDatadogButtonProps) {
  const buildDatadogQuery = () => {
    const names = [];
    if (primaryClientName) {
      names.push(`@usr.name:"${primaryClientName}"`);
    }
    if (coClientName) {
      names.push(`@usr.name:"${coClientName}"`);
    }

    if (names.length === 0) return '';

    const nameQuery = names.length > 1 ? `(${names.join(' OR ')})` : names[0];

    return `@type:session @session.type:user ${nameQuery}`;
  };

  const query = buildDatadogQuery();
  const baseUrl = 'https://app.datadoghq.com/rum/sessions';

  const now = Date.now();
  const thirtyDaysAgo = now - 30 * 24 * 60 * 60 * 1000;

  const params = new URLSearchParams({
    query,
    agg_m: 'count',
    agg_m_source: 'base',
    agg_t: 'count',
    fromUser: 'false',
    'saved-view-id': '1264342',
    sort_by: 'time',
    sort_order: 'desc',
    viz: 'stream',
    from_ts: thirtyDaysAgo.toString(),
    to_ts: now.toString(),
    live: 'true',
  });

  const datadogUrl = `${baseUrl}?${params.toString()}`;

  return (
    <TrackedButton
      variant="secondary"
      elementName="admin-action-buttons-open-datadog-button"
      disabled={!query}
      render={<a href={datadogUrl} target="_blank" rel="noreferrer noopener" />}
    >
      Open Datadog Sessions
      <SquareArrowOutUpRight />
    </TrackedButton>
  );
}

export default OpenDatadogButton;
